import { useTranslation } from 'react-i18next';
import { SysTable } from '../../system/SysTable';
import type { ILayoutWidthsCardProps } from './ILayoutWidthsCardProps';
import { layoutTypes } from './layoutDefaults';

/**
 * Картка «Типова ширина за типом поля» (прототип v4 gsTypes): тип поля 600, типові поля приглушено, вибір ширини (S · 1 одиниця, M · 2
 * одиниці, L · увесь рядок); змінене проти базового значення позначено крапкою з підказкою «Типово M» / «Глобально M».
 */
export function LayoutWidthsCard({ layout, base, canEdit, onSave, global }: ILayoutWidthsCardProps) {
  const { t } = useTranslation();
  const rows = layoutTypes.map((type) => {
    const value = layout.widths[type] ?? 'M';
    const before = base.widths[type] ?? 'M';
    return {
      key: type,
      cells: [
        <span key="t" className="sp-strong">{t(`sysCust.layout.types.${type}`)}</span>,
        <span key="e" className="sp-muted">{t(`sysCust.layout.examples.${type}`, { count: layout.longOption })}</span>,
        <span key="w" className="cu-width">
          <select className="sp-select cu-width__select" value={value} disabled={!canEdit} aria-label={t('sysCust.layout.widthFor', { type: t(`sysCust.layout.types.${type}`) })}
            onChange={(e) => onSave({ ...layout, widths: { ...layout.widths, [type]: e.target.value } })}>
            {['S', 'M', 'L'].map((w) => <option key={w} value={w}>{t(`sysCust.layout.widths.${w}`)}</option>)}
          </select>
          {value !== before && <span className="cu-width__dot" title={t(global ? 'sysCust.layout.defaultIs' : 'sysCust.layout.globalIs', { width: before })} />}
        </span>,
      ],
    };
  });
  return (
    <section className="cu-panel cu-widths" aria-label={t('sysCust.layout.widthsTitle')}>
      <div className="cu-titles"><div className="sp-eyebrow">{t('sysCust.layout.widthsTitle')}</div><div className="sp-muted">{t('sysCust.layout.widthsDesc')}</div></div>
      <SysTable columns="minmax(160px, 0.9fr) minmax(0, 1.6fr) 160px" minWidth={600} rows={rows}
        head={[t('sysCust.layout.fieldType'), t('sysCust.layout.typical'), t('sysCust.layout.width')]} label={t('sysCust.layout.widthsTitle')} />
    </section>
  );
}
